import { setGlobalizationSettings } from '@core/store/globalization-settings/globalization-settings.actions';
import { createReducer, on } from '@ngrx/store';
import { ApplicationGlobalizationSettings } from '../../../camms-risk/models/region-settings/application-globalization-settings';

export const initialState: ApplicationGlobalizationSettings = {};
export const globalizationSettingsReducer = createReducer(
    initialState,
    on(setGlobalizationSettings, (state, { globalizationSettings }) => ({
        ...state,
        globalizationSettings,
    })),
);
